import { render, staticRenderFns } from "./Page5.vue?vue&type=template&id=36f8a783&scoped=true&"
import script from "./Page5.vue?vue&type=script&lang=js&"
export * from "./Page5.vue?vue&type=script&lang=js&"
import style0 from "./Page5.vue?vue&type=style&index=0&id=36f8a783&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8a783",
  null
  
)

export default component.exports